/**
 * Created by Carsten Bühler
 * User: CBuehler on 26.11.2015
 * Copyright: xdot GmbH 2015
 */
'use strict';

//Includes
import React from 'external/react';
import {
    AppContext,
    ConfirmFormContainer,
    ContextContainer,
    DataLinkContainer,
    DataUtil,
    FormActions,
    PortletComponent,
    RemoteDataActions,
    ScrollableDataListRV,
    wrapWithCommonFormContainer
} from 'plugin/liferay-widgets-react-web';
import { Col, Container, Dropdown, Row } from 'external/react-bootstrap';
//Current Module
import FliwasObjectMasterDetailList from '../components/FliwasObjectMasterDetailList';
import SelectObjectErrorMessage from '../components/SelectObjectErrorMessage';
import NamedListListItem from '../components/NamedListListItem';
import NamedListEditForm from '../components/NamedListEditForm';
import FliwasDetailsBox from '../components/FliwasDetailsBox';
import FliwasActionButtons from '../components/FliwasActionButtons';
import FliwasObjectListItem from '../components/FliwasObjectListItem';
import AssetLinkChooser from '../components/AssetLinkChooser';

import { getBomListStore, getNamedListStore } from '../stores/StoreFactory';

import { ClassNames, GROUP_NAMED_LISTS } from '../constants/Constants';

import NamedListActions from '../actions/NamedListActions';
import BomListActions from '../actions/BomListActions';
import NamedListWebApi from '../webapi/NamedListWebApi';

//Stores
const NamedListStore = getNamedListStore(AppContext);
const BomListStore = getBomListStore(AppContext);

//DataLinks
const NamedListListLinkCHOC = DataLinkContainer.link(ScrollableDataListRV, ['list'], NamedListStore);
const NamedListEditFormHoc = wrapWithCommonFormContainer(NamedListEditForm);

const AssetLinkChooserHoc = wrapWithCommonFormContainer(AssetLinkChooser);

class NamedListMasterDetailsWidget extends PortletComponent {

    constructor(props){
        super(props);

        this.DATA = {
            SELECTED_NAMED_LIST: this.withCtx('_SelectedNamedList'),
            SELECT_OBJECT_LIST: this.withCtx('_SelectedObjectList'),

            FORM_DELETE_OBJECT: this.withCtx('_DeleteNamedList'),
            FORM_EDIT_NAMED_LIST: this.withCtx('_EditNamedList'),

            FORM_ADD_OBJECT: this.withCtx('_AddObject'),
        };

        this.onNamedListFormSubmit = this.onNamedListFormSubmit.bind(this);
        this.newNamedList = this.newNamedList.bind(this);
        this.selectNamedList = this.selectNamedList.bind(this);
    }

    static getStores(){
        return [
            NamedListStore,
            BomListStore
        ];
    }

    static calculateState(prevState, undefined, DATA){
        return {
            selectedNamedList: NamedListStore.getRemoteData(DATA.SELECTED_NAMED_LIST),
            selectedObjectList: BomListStore.getRemoteData(DATA.SELECT_OBJECT_LIST)
        };
    }

    componentDidMount(){
        const linkedQuery = {
            $byEntries: ClassNames.AssetCategory + '/' + this.DATA.SELECTED_NAMED_LIST + '/entries',
            byClassName: ClassNames.AssetCategory
        };
        BomListActions.bomList(this.DATA.SELECT_OBJECT_LIST, { ...linkedQuery });
    }

    selectNamedList(namedList){
        //Current Object
        NamedListActions.item(this.DATA.SELECTED_NAMED_LIST, { id: namedList.id });
    }

    newNamedList(){
        FormActions.startEditFormItem(this.DATA.FORM_EDIT_NAMED_LIST, {});
    }

    editNamedList(){
        FormActions.startEditFormItem(this.DATA.FORM_EDIT_NAMED_LIST, DataUtil.asItem(this.state.selectedNamedList));
    }

    onNamedListFormSubmit(data){
        if (data.id) {
            NamedListActions.update(data, this.DATA.FORM_EDIT_NAMED_LIST, true);
        } else {
            NamedListActions.add(data, this.DATA.FORM_EDIT_NAMED_LIST, true);
        }
    }

    onClickNamedList(){
        const object = DataUtil.asItem(this.state.selectedNamedList);
        FormActions.startEditFormItem(this.DATA.FORM_DELETE_OBJECT, object);
    }

    deleteObject(object){
        NamedListActions.delete(object, this.DATA.FORM_DELETE_OBJECT, true);
        RemoteDataActions.remove(this.DATA.SELECTED_NAMED_LIST, ClassNames.AssetCategory);
        //RemoteDataActions.remove(this.DATA.SELECT_OBJECT_LIST, undefined);
    }

    onObjectAdd(){
        FormActions.startEditFormItem(this.DATA.FORM_ADD_OBJECT, {});
    }

    onObjectAddSubmit(data){
        const selectedList = DataUtil.asItem(this.state.selectedNamedList);
        NamedListWebApi.update({
            ...selectedList,
            entries: [...selectedList.entries, { className: data.className, classPK: data.id }]
        });
        FormActions.stopEditFormItem(this.DATA.FORM_ADD_OBJECT);
    }

    isConfigurationNeeded(config){
        return false;
    }

    renderPortlet(config){
        const selectedNamedListDataItem = this.state.selectedNamedList && this.state.selectedNamedList,
            selectedNamedList = DataUtil.asItem(selectedNamedListDataItem),
            selectedObjectListDataItem = this.state.selectedObjectList && this.state.selectedObjectList;
        //selectedObjectList = DataUtil.asItem(selectedObjectListDataItem);

        /*eslint react/jsx-no-bind: 0*/
        return (
            <Container fluid>
                <Row>
                    <FliwasObjectMasterDetailList createClick={this.newNamedList}>

                        <NamedListListLinkCHOC list={GROUP_NAMED_LISTS}
                                               activeIds={selectedNamedList}
                                               size="large"
                                               ListItem={NamedListListItem}
                                               onClick={this.selectNamedList}/>

                    </FliwasObjectMasterDetailList>
                    <Col lg={9} md={12} sm={12} xs={12}>
                        <Row>

                            <NamedListEditFormHoc formId={this.DATA.FORM_EDIT_NAMED_LIST}
                                                  onFormSubmit={this.onNamedListFormSubmit}/>

                            {!selectedNamedList && selectedObjectListDataItem &&
                                <Col lg={12} md={12} sm={12} xs={12}>
                                    <SelectObjectErrorMessage content="Bitte Benannte Liste auswählen"/>
                                </Col>
                            }

                            <ConfirmFormContainer
                                formId={this.DATA.FORM_DELETE_OBJECT}
                                title="Löschen"
                                Content={({ formData }) => (
                                    'Wollen Sie Liste \'' + formData.title + '\' wirklich löschen?')}
                                editRequired={false}
                                onFormSubmit={this.deleteObject.bind(this)}
                            />

                            {selectedNamedList && selectedObjectListDataItem &&
                                <Col xs={12} className="nopadding">
                                    <div className="padding-box">
                                        <div className="margin-bottom">
                                            <FliwasActionButtons>
                                                <Dropdown.Item title="Neues Objekt hinzufügen"
                                                               onClick={this.onObjectAdd.bind(this)}>
                                                    Neues Objekt hinzufügen
                                                </Dropdown.Item>
                                                <Dropdown.Item title="Bearbeiten"
                                                               onClick={this.editNamedList.bind(this)}>
                                                    Bearbeiten
                                                </Dropdown.Item>
                                                <Dropdown.Item title="Löschen"
                                                               onClick={this.onClickNamedList.bind(this)}>
                                                    Gesamte Liste L&ouml;schen
                                                </Dropdown.Item>
                                            </FliwasActionButtons>
                                        </div>
                                        <FliwasDetailsBox item={selectedNamedList}/>

                                        <ScrollableDataListRV list={selectedObjectListDataItem}
                                                              size="large"
                                                              rowHeight={80}
                                                              selectedNamedList={selectedNamedList}
                                                              onClickDelete={true}
                                                              ListItem={FliwasObjectListItem}/>

                                        <AssetLinkChooserHoc formId={this.DATA.FORM_ADD_OBJECT}
                                                             onFormSubmit={this.onObjectAddSubmit.bind(this)}/>
                                    </div>
                                </Col>}
                        </Row>
                    </Col>
                </Row>
            </Container>
        );
    }
}

NamedListMasterDetailsWidget.propTypes = {};

export default ContextContainer.create(NamedListMasterDetailsWidget);



// WEBPACK FOOTER //
// ./js/widgets/NamedListMasterDetailsWidget.jsx